<!--
 * @Author: zcc zcc-2578840576 2578840576@qq.com
 * @Date: 2026-03-11 17:36:41
 * @LastEditors: zcc zcc-2578840576 2578840576@qq.com
 * @LastEditTime: 2026-03-26 17:10:24
 * @FilePath: \hzs-nutra-wecom-shop\src\views\activity\activityCoupon.vue
 * @Description: 门店活动 - 创建活动 - 选择优惠券
-->

<template>
  <div class="page-container">
    <!-- 下拉刷新 + 上拉加载 -->
    <div class="list-container">
      <van-pull-refresh
        v-if="state.couponList.length > 0"
        class="scroll-view"
        v-model="state.refreshing"
        pull-distance="80"
        @refresh="onRefresh"
      >
        <van-list
          v-model:loading="state.loading"
          :finished="state.finished"
          finished-text="没有更多了"
          @load="onLoad"
          v-model:error="state.error"
          error-text="请求失败，点击重新加载"
          :offset="100"
        >
          <!-- 数据列表 -->
          <div class="activity-list">
            <div
              v-for="item in state.couponList"
              :key="item.uuid"
              :class="[
                'couponItem flex justify-sb align-center',
                state.selectedCouponList.includes(item.uuid) ? 'selected' : '',
              ]"
              @click="onClickCoupon(item)"
            >
              <div class="couponCard flex align-center">
                <div
                  class="payment flex align-end"
                  v-if="item.discount_type === 1"
                >
                  <span class="money">{{ item.discount_amount }}</span>
                  <span class="unit">元</span>
                </div>
                <div
                  class="payment flex align-end"
                  v-if="item.discount_type === 2"
                >
                  <span class="exchange">兑换券</span>
                </div>

                <van-divider vertical dashed :hairline="false"></van-divider>

                <div class="flex flex-col justify-center align-start">
                  <p class="title">{{ item.coupon_name }}</p>
                  <p class="time">有效期：{{ item.endTime }}</p>
                </div>
              </div>

              <div
                class="selectedStatus flex flex-col justify-center align-center"
              >
                <p
                  v-if="!state.selectedCouponList.includes(item.uuid)"
                  class="btn"
                >
                  选择
                </p>
                <p
                  v-if="state.selectedCouponList.includes(item.uuid)"
                  class="btn selected"
                >
                  已选择
                </p>

                <p class="num">
                  剩余:{{
                    item.remainingNum > 999 ? "999+" : item.remainingNum
                  }}
                </p>
              </div>
            </div>
          </div>

          <!-- 自定义加载提示 -->
          <template #loading>
            <div class="loading-wrapper">
              <van-loading type="spinner" size="20px" />
              <span>加载中...</span>
            </div>
          </template>
        </van-list>
      </van-pull-refresh>

      <!-- 空状态 -->
      <van-empty
        class="empty-wrapper"
        v-if="state.couponList.length === 0 && !state.loading"
        description="暂无数据"
      />
    </div>
    <div class="mainContent h100"></div>

    <div class="bottom_button_box">
      <van-button
        round
        block
        type="primary"
        :color="state.selectedCouponList.length > 0 ? '#DCBB89' : '#999'"
        class="save-btn"
        @click="onClickConfirm"
      >
        确 认
      </van-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import {
  showToast,
  showLoadingToast,
  showSuccessToast,
  showFailToast,
  showDialog,
} from "vant";
import { useRoute, useRouter, onBeforeRouteUpdate } from "vue-router";
import dayjs from "dayjs";
import { useCouponStore } from "@/stores";

import otherApi from "@/utils/api/other.js";
// --------------------------------------- 变量
const router = useRouter();
const route = useRoute();
// --------------------------------------- 生命周期
// --------------------------------------- 数据
// 直播列表数据
const state = reactive({
  userInfo: JSON.parse(localStorage.getItem("userInfo")), // 用户信息
  weComUserInfo: JSON.parse(localStorage.getItem("weComUserInfo")), // 企业微信用户信息
  departmentdata: JSON.parse(localStorage.getItem("departmentdata")), // 部门数据
  loading: false, // 列表数据是否正在加载
  refreshing: false, // 列表数据是否正在刷新
  finished: false, // 列表数据是否加载完毕
  error: false, // 列表数据是否加载失败
  selectedCouponList: [], // 选中的优惠券列表
  // 列表数据
  couponList: [],
  hasMore: true, // 是否还有更多数据
  pagination: {
    total: 0,
    page: 1,
    page_size: 10,
  },
});
// 上拉加载更多
const onLoad = async () => {
  try {
    getCouponList();
  } catch (error) {
    showFailToast("加载失败");
    state.error = true; // 错误时设置 error，让组件显示重试
  }
};

// 下拉刷新
const onRefresh = async () => {
  state.finished = false;
  state.pagination.page = 1;
  try {
    getCouponList();
    // showSuccessToast("刷新成功");
  } catch (error) {
    // showFailToast("刷新失败");
  } finally {
    state.refreshing = false;
  }
};
// --------------------------------------- 方法、事件
onMounted(() => {
  // 初始化时获取优惠券列表
  getCouponList();
});
// 方式 1：直接获取（响应式）
const selCoupon = route.query.selCoupon || "";
state.selectedCouponList = selCoupon
  ? selCoupon.split(",").map((item) => item.uuid)
  : [];
// 选择优惠券
const onClickCoupon = (item) => {
  if (state.selectedCouponList.includes(item.uuid)) {
    state.selectedCouponList.splice(0, 1);
  } else {
    state.selectedCouponList = [item.uuid];
  }
  // if (state.selectedCouponList.includes(item.uuid)) {
  //     state.selectedCouponList = state.selectedCouponList.filter(
  //         (v) => v !== item.uuid
  //     );
  // } else {
  //     state.selectedCouponList.push(item.uuid);
  // }
};
// 确认选择优惠券
const onClickConfirm = () => {
  if (state.selectedCouponList.length === 0) {
    showFailToast("请选择优惠券");
    return;
  }
  const selected = state.selectedCouponList.map((c) => {
    let item = state.couponList.find((item) => item.uuid === c);
    return {
      uuid: item.uuid,
      coupon_name: item.coupon_name,
      discount_type: item.discount_type,
      discount_amount: item.discount_amount,
    };
  });
  // 存储优惠券数据到 Vuex
  useCouponStore().setCoupon(JSON.stringify(selected));
  // 通过 query 带回数据（URL 会变长，不适合大数据）
  // router.push({
  //     path: "/activityAdd",
  //     query: {},
  // });
  // ✅ 返回上一页（不会新增历史记录）
  router.back();
};
// --------------------------------------- 请求
// 获取优惠券列表
const getCouponList = async () => {
  const toast = showLoadingToast({
    message: "加载中...",
    forbidClick: true,
    duration: 0,
  });
  try {
    const res = await otherApi.getCouponList({
      status: 1,
      page: state.pagination.page,
      page_size: state.pagination.page_size,
    });

    if (res.code !== 200) {
      state.error = true;
      return;
    }

    // 处理数据
    let list =
      res.data?.map((item) => ({
        ...item,
        startTime: dayjs(item.fixed_start_time).format("MM.DD HH:mm"),
        endTime: item.fixed_end_time
          ? dayjs(item.fixed_end_time).format("MM.DD HH:mm")
          : "无",
        remainingNum:
          item?.total_quantity > item?.usage_quantity
            ? item.total_quantity - item.usage_quantity
            : 0,
      })) || [];

    // 更新列表
    if (state.pagination.page === 1) {
      state.couponList = list;
    } else {
      state.couponList = state.couponList.concat(list);
    }

    state.pagination.total = res.cnt || 0;

    // 关键：判断是否还有更多数据
    const currentLength = state.couponList.length;
    const hasMore = currentLength < state.pagination.total;

    if (!hasMore) {
      state.finished = true; // 没有更多数据了
    } else {
      state.pagination.page += 1; // 页码+1，为下次加载做准备
    }

    // 关键：手动关闭 loading，让 van-list 知道加载完成
    state.loading = false;
  } catch (error) {
    state.error = true;
  } finally {
    toast.close();
    // state.loading = false; // 关键：无论成功失败，都要关闭 loading
  }
};
</script>

<style lang="scss" scoped>
/* @use 'xxx.scss' as *; */
/*
    .page-container
        ---- 主体内容
        .mainContent

        ---- 底部操作栏
        .bottom_button_box
    @supports

    **** 在 @/scss/common.scss ****
*/
.page-container {
  height: 100%;
}
.custom-nav-bar {
  position: sticky;
  top: 0;
  left: 0;
}
.list-container {
  // height: calc(100vh - 120px);
  // background: #f5f5f5;
}
.scroll-view {
}
.activity-list {
  padding: 10px 17px;
  height: calc(100%);
}

.couponItem {
  border: 2rpx solid #fff;
  &:not(:first-child) {
    margin-top: 10px;
  }

  .couponCard {
    //   width: 276px;
    flex: 1;
    min-height: 115px;
    padding: 5px 11px;
    margin-right: 8px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    border: 2px solid #fff;

    .van-divider {
      height: 100px;
    }
    .payment {
    }

    .payment .money {
      height: 44px;
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 38px;
      color: #9f3411;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .payment .exchange {
      height: 44px;
      font-family: Arial, Arial;
      font-weight: bold;
      font-size: 20px;
      line-height: 44px;
      color: #9f3411;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }
    .payment .unit {
      height: 22px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #9f3411;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    .title {
      min-height: 25px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 500;
      font-size: 18px;
      line-height: 25px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;

      margin-bottom: 8px;
    }
    .time {
      height: 20px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #999999;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }
  &.selected {
    .couponCard {
      border: 2px solid #dcbb89;
    }
  }

  .selectedStatus {
    width: 73px;

    .btn {
      width: 100%;
      height: 38px;
      line-height: 38px;
      background: #dcbb89;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #dcbb89;

      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: #ffffff;
      text-align: center;
      font-style: normal;
      text-transform: none;

      &.selected {
        background: #999999;

        color: #fff;
      }
    }
    .num {
      height: 20px;
      font-family:
        PingFang SC,
        PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #ff7123;
      text-align: center;
      font-style: normal;
      text-transform: none;

      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
    }
  }
}
</style>
